import { CommonModule, LowerCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { globals } from '../../../environments/globals';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'country-switcher',
    styleUrls: ['./country-switcher.scss'],
    templateUrl: './country-switcher.html',
    standalone: true,
    imports: [CommonModule, LowerCasePipe]
})
export class CountrySwitcherComponent implements OnInit {
  mediaURL: string = environment.mediaURL;
  countries: any[] = globals.countries.filter((site: { active: boolean; }) => site.active);
  constructor() { }

  ngOnInit() {
  }
}
